import { render } from "./PontaPass.vue?vue&type=template&id=c611e638&scoped=true"
import script from "./PontaPass.vue?vue&type=script&lang=js"
export * from "./PontaPass.vue?vue&type=script&lang=js"

import "./PontaPass.vue?vue&type=style&index=0&id=c611e638&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c611e638"]])

export default __exports__